<template>
<OnePaneLayout v-if="layoutStore.mode === 'one'" />

<MultiPaneLayout v-else />
</template>

<script setup lang="ts">
import { useLayoutStore } from '@/stores/layout'
import MultiPaneLayout from '@/layouts/MultiPaneLayout.vue'
import OnePaneLayout from '@/layouts/OnePaneLayout.vue'

// The layout is chosen once, when the app loads
const layoutStore = useLayoutStore()
</script>
